import { TableActionOrGroup, isTableActionGroup } from '../types';

export type UseFilterShownTableActionsArgs = {
    actions: TableActionOrGroup<any>[];
    data: any[];
};

export type UseFilterShownTableActionsReturnValue = {
    shownActions: TableActionOrGroup<any>[];
};

export const useFilterShownTableActions = ({
    actions,
    data,
}: UseFilterShownTableActionsArgs): UseFilterShownTableActionsReturnValue => {
    const shownActions = actions.filter((action) => {
        if (isTableActionGroup(action)) {
            return action.actions.some((action) => action.shouldShow(data));
        } else {
            return action.shouldShow(data);
        }
    });
    return { shownActions };
};
